module.exports = __webpack_public_path__ + "img/slider_2.16cd8189.jpg";